import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { IonIcon, IonInput } from "@ionic/react";
import { CustomIonFormProps } from "../../pages/addResult/components";
import "./R6IonInput.css";
import { lockClosed } from "ionicons/icons";

export const R6IonInput: FC<CustomIonFormProps> = ({
    name,
    testId,
    rules = {},
    slot = "",
    className = "",
    type,
    inputMode,
    onFocus,
    onBlur: customOnBlur,
    disabled = false,
    placeholder,
    autocapitalize = "words",
    maxLength,
    id,
    min,
    max,
    step,
    debounce,
    onClick,
    readonly,
    label,
}) => {
    return (
        <Controller
            disabled={disabled}
            rules={rules}
            render={({ field: { onChange, onBlur, ref, value, ...rest } }) => {
                const forwardChange = (event: CustomEvent) => {
                    const detailValue = (event.detail as any)?.value ?? "";
                    const target = event.target as HTMLInputElement | null;
                    if (target) {
                        (target as any).value = detailValue;
                    }
                    onChange(detailValue);
                };

                return (
                    <>
                        <IonInput
                            id={id}
                            ref={ref}
                            data-testid={testId || name}
                            color="medium" // this helps with the cursor being more visible on light backgrounds
                            value={value ?? ""}
                            onIonChange={forwardChange}
                            onIonInput={forwardChange}
                            type={type}
                            inputMode={inputMode}
                            onIonFocus={onFocus}
                            onIonBlur={(e) => {
                                onBlur();
                                customOnBlur && customOnBlur();
                            }}
                            maxlength={maxLength}
                            min={min}
                            max={max}
                            step={step}
                            slot={slot}
                            autocapitalize={autocapitalize}
                            className={className}
                            placeholder={placeholder}
                            labelPlacement="floating"
                            debounce={debounce}
                            onClick={onClick}
                            readonly={readonly}
                            label={label}
                            {...rest}
                        />
                        {disabled && (
                            <IonIcon
                                icon={lockClosed}
                                className={"input-lock-icon"}
                            />
                        )}
                    </>
                );
            }}
            name={name}
        />
    );
};
